import { render, staticRenderFns } from "./EngMainInfoVideo.vue?vue&type=template&id=27a53536&"
import script from "./EngMainInfoVideo.vue?vue&type=script&lang=js&"
export * from "./EngMainInfoVideo.vue?vue&type=script&lang=js&"
import style0 from "./EngMainInfoVideo.vue?vue&type=style&index=0&id=27a53536&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports